<template>
    <div class="wrapper" :data-open="state === 'open' ? 1 : 0">
        <div class="bg" @click="setState('close')"></div>
        <div ref="card" class="card" :data-state="isMove ? 'move' : state" :style="{ top: `${isMove ? y : calcY()}px` }">
            <div class="pan-area-tabs" ref="pan" v-if="currentTab">
                <div class="return-button d-flex justify-content-start align-items-center w-100 h-100">
                    <div @click="$emit('returnTab')" class="button-grid">
                        <div v-if="currentTab > 1" class="d-flex justify-content-center align-items-center">
                            <icon name="chevron-left" color="var(--secondary)" />
                        </div>
                        <div v-if="currentTab > 1" class="return d-flex justify-content-center align-items-center">
                            {{ $t('button_text38') }}
                        </div>
                    </div>
                </div>
                <div class="local-name-container d-flex justify-content-center align-items-center w-100 h-100">
                    <slot name="local-name"></slot>
                </div>
                <div class="close-bottom-sheet d-flex justify-content-end align-items-center w-100 h-100" @click="setState('close')">
                    <icon name="times" color="white" />
                </div>
            </div>
            <div v-else class="pan-area" ref="pan">
                <div class="local-name d-flex justify-content-center align-items-center w-100 h-100">
                    <slot name="header"></slot>
                </div>
                <div class="close-bottom-sheet d-flex justify-content-center align-items-center h-100" @click="setState('close')">
                    <icon name="times" color="white" />
                </div>
            </div>
            <div class="bottom-sheet-container">
                <div v-if="search" class="bottom-sheet-search">
                    <slot name="search"></slot>
                </div>
                <div class="bottom-sheet-content">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/chevron-left'

import Hammer from 'hammerjs'
export default {
    props: {
        openY: {
            type: Number,
            default: 0.1,
        },
        halfY: {
            type: Number,
            default: 0.8,
        },
        defaultState: {
            type: String,
            default: 'close',
        },
        search: {
            type: Boolean,
            default: false,
        },
        currentTab: {
            type: Number,
            default: 0,
        },
        isMap: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mc: null,
            y: 0,
            startY: 0,
            isMove: false,
            state: this.defaultState,
            rect: {},
        }
    },
    mounted() {
        if (this.$refs.card) {
            window.onresize = () => {
                this.rect = this.$refs.card.getBoundingClientRect()
            }

            this.rect = this.$refs.card.getBoundingClientRect()
            this.mc = new Hammer(this.$refs.pan)
            this.mc.get('pan').set({ direction: Hammer.DIRECTION_ALL })
            this.mc.on('panup pandown', (evt) => {
                this.y = evt.center.y - 16
            })
            this.mc.on('panstart', (evt) => {
                this.startY = evt.center.y
                this.isMove = true
            })
            this.mc.on('panend', (evt) => {
                this.isMove = false
                switch (this.state) {
                    case 'open':
                        if (this.startY - evt.center.y < -200) {
                            this.state = 'close'
                        }
                        break
                }
            })
        }
    },
    beforeDestroy() {
        this.mc.destroy()
        window.onresize = null
    },
    methods: {
        calcY() {
            switch (this.state) {
                case 'close':
                    return this.rect.height
                case 'open':
                    return 40
                default:
                    return this.y
            }
        },

        setState(state) {
            this.state = state
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/Mobile/bottom-sheet.scss';
</style>
